import UserTab from './UserTab';

export default UserTab;
